import { render, staticRenderFns } from "./JackpotHelp.vue?vue&type=template&id=6cf04d8a&"
import script from "./JackpotHelp.vue?vue&type=script&lang=js&"
export * from "./JackpotHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports